import { render } from "./InputImgProd.vue?vue&type=template&id=1272996c&scoped=true"
import script from "./InputImgProd.vue?vue&type=script&lang=js"
export * from "./InputImgProd.vue?vue&type=script&lang=js"

import "./InputImgProd.vue?vue&type=style&index=0&id=1272996c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1272996c"]])

export default __exports__